<div class="header">
  <h3>จัดการคำร้อง</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row">
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" [(ngModel)]="invoiceNumber" placeholder="เลขที่เอกสาร">
        <label for="invoice-number">เลขที่เอกสาร</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" [(ngModel)]="requestNo" placeholder="เลขที่คำร้อง">
        <label for="request-no">เลขที่คำร้อง</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" [(ngModel)]="requestUser" placeholder="ชื่อผู้ขอ">
        <label for="request-user">ชื่อผู้ขอ</label>
      </div>
    </div>
  </div>
  <div class="row m-t-10">
    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-left" autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
              ngbDropdownToggle placeholder="วันที่ออกเอกสาร" readonly>
          <label for="calendarDropdown">วันที่คำร้อง</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">ตั้งแต่</div>
            <div class="col" style="padding-left: 30px">ถึง</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown"
            selectId="request-type"
            [options]="requestTypes"
            [(ngModel)]="requestType"
            [autoDisplayFirst]="false"
            placeholder="ประเภทคำร้อง">
        </p-dropdown>
        <label for="request-type">ประเภทคำร้อง</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown"
            selectId="status"
            [options]="statusChoices"
            [(ngModel)]="status"
            [autoDisplayFirst]="false"
            placeholder="สถานะ">
        </p-dropdown>
        <label for="status">สถานะ</label>
      </div>
    </div>
  </div>
</div>
<div class="box-parent position-relative z-1">
  <app-custom-pagination
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="pageChanged()"
      (optionChange)="optionChanged()"
      *ngIf="!loading && totalItems">
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>

  <div class="row m-t-20" *ngIf="!loading && !totalItems">
    <div class="col-12 text-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>
  <div class="m-t-20 text-center" *ngIf="!loading && totalItems">
    <p-table #tt styleClass="table" [value]="tableData" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">ลำดับ</th>
          <th>วันที่คำร้อง</th>
          <th>เลขที่คำร้อง</th>
          <th>ประเภทคำร้อง</th>
          <th>สถานะ</th>
          <th>ผู้ขอ</th>
          <th>รายการเอกสาร</th>
          <th>รายละเอียด</th>
          <th *ngIf="isSystemAdmin">ดำเนินการ</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.request_date}}</td>
          <td>{{data.request_no}}</td>
          <td>{{data.request_type_display}}</td>
          <td>
            <div class="row">
              <div class="col-8">{{data.status_display}}</div>
              <div class="col-auto">
                <span class="status-grey" [ngClass]="{
                  'status-green': data.status === 'approved' ,
                  'status-red': data.status === 'rejected' ,
                  'status-orange': data.status === 'pending'}"></span>
              </div>
            </div>
          </td>
          <td>{{data.request_user}}</td>
          <td>
            <i class="fa fa-eye pointer" (click)="openModal(documentDetailsModal, data, 'lg')"></i>
          </td>
          <td>
            <i class="fa fa-eye pointer" *ngIf="data.request_type === 'edit_document' || data.status !== 'pending'" (click)="openModal(requestDetailsModal, data)"></i>
            <span *ngIf="data.request_type !== 'edit_document' && data.status === 'pending'">-</span>
          </td>
          <td *ngIf="isSystemAdmin">
            <button class="btn btn-dv"
                [disabled]="data.status !== 'pending'"
                (click)="openModal(confirmModal, data)">
              อนุมัติ
            </button>
            <button class="btn btn-dv btn-delete"
                [disabled]="data.status !== 'pending'"
                (click)="openModal(rejectModal, data)">
              ปฏิเสธ
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<ng-template #documentDetailsModal>
  <div class="modal-header">
    <h5 class="modal-title">รายการเอกสาร</h5>
  </div>
  <div class="modal-body p-0 text-center">
    <p-table styleClass="table" [value]="selectedRequest.tax_data_display">
      <ng-template pTemplate="header">
        <tr>
          <th width="50px">ลำดับ</th>
          <th>วันที่เอกสาร</th>
          <th>เลขที่เอกสาร</th>
          <th>ประเภทเอกสาร</th>
          <th>บริษัท</th>
          <th>ยอดขาย</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1}}</td>
          <td>{{data.issue_date_display}}</td>
          <td>{{data.header_invoice_number}}</td>
          <td>{{data.rd_document_type_display}}</td>
          <td>{{data.seller_name}}</td>
          <td>{{data.total_items_total_payment | number: '1.2-2'}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="closeModal()">
      ปิด
    </button>
  </div>
</ng-template>

<ng-template #requestDetailsModal>
  <div class="modal-header">
    <h5 class="modal-title">รายละเอียด</h5>
  </div>
  <div class="modal-body">
    <ul *ngIf="selectedRequest.details_display.length">
      <li *ngFor="let item of selectedRequest.details_display">{{item}}</li>
    </ul>
    <span *ngIf="selectedRequest.status === 'rejected'" class="text-red m-l-20">* เหตุผล ({{selectedRequest.response_user}}): {{selectedRequest.reason}}</span>
    <span *ngIf="selectedRequest.status === 'approved'" class="text-green m-l-20">* อนุมัติโดย {{selectedRequest.response_user}}</span>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="closeModal()">
      ปิด
    </button>
  </div>
</ng-template>

<ng-template #confirmModal>
  <div class="modal-header">
    <h5 class="modal-title">ยืนยันการอนุมัติ</h5>
  </div>
  <div class="modal-body text-center p-y-40">
    คุณแน่ใจหรือไม่ที่จะอนุมัติคำร้องฉบับนี้
  </div>
  <div class="modal-footer">
    <button class="btn btn-dv btn-wide" (click)="approve()" [disabled]="submitting">
      <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i>
      ยืนยัน
    </button>
    <button class="btn btn-outline-secondary" (click)="closeModal()" [disabled]="submitting">
      ยกเลิก
    </button>
  </div>
</ng-template>

<ng-template #rejectModal>
  <div class="modal-body">
    <label for="reason">กรุณากรอกเหตุผล <span class="text-red">*</span></label>
    <textarea id="reason" type="text" rows="3" class="form-control" [(ngModel)]="reason"></textarea>
  </div>
  <div class="modal-footer">
    <button class="btn btn-dv btn-wide" (click)="reject()" [disabled]="submitting">
      <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i>
      ยืนยัน
    </button>
    <button class="btn btn-outline-secondary" (click)="closeModal()" [disabled]="submitting">
      ยกเลิก
    </button>
  </div>
</ng-template>

<ng-template #resultModal>
  <div class="modal-body p-y-40 text-center">
    {{resultMessage}}
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="closeModal(true)">
      ปิด
    </button>
  </div>
</ng-template>


// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request.component.html